import { render, staticRenderFns } from "./ListModules.vue?vue&type=template&id=0cd22bb2&scoped=true"
import script from "./ListModules.vue?vue&type=script&lang=ts"
export * from "./ListModules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd22bb2",
  null
  
)

export default component.exports